import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface IbuttonState {
  isButtonShown: boolean;
}

const initialState: IbuttonState = {
  isButtonShown: false,
};

export const wayBillButtonsSlice = createSlice({
  name: "ButtonSlice",
  initialState,
  reducers: {
    setIsButtonShown: (state, action: PayloadAction<boolean>) => {
      state.isButtonShown = action.payload;
    },
  },
});

export const { setIsButtonShown } = wayBillButtonsSlice.actions;
export const wayBillButton = wayBillButtonsSlice.reducer;
